import ReportPageTemplate from "./Components/ReportPageTemplate";

export default function GraphReports() {
  const reportTypes = [
    { label: "Monthly Occupancy Chart", api: "/pms/reports/monthly-occupancy-chart" },
    { label: "Monthly Revenue Chart", api: "/pms/reports/monthly-revenue-chart" },
  ];

  return (
    <ReportPageTemplate
      title="Graphs & Charts"
      desc="Dynamic occupancy & revenue analytics"
      reportTypes={reportTypes}
    />
  );
}
